<template>
	<div>
		<img src="/assets/images/desktop/programa.png"
		     class="w-100 d-none d-xl-block d-lg-block d-md-none d-sm-none"
		     draggable="false"
		     alt="">
		<img src="/assets/images/movil/programa.png"
		     class="w-100 d-block d-xl-none d-lg-none d-md-block d-sm-block"
		     draggable="false"
		     alt="">
		<div class="border-5 border-bottom border-dark-pink"></div>
		<div class="container py-5">
			<div class="row">
				<div class="col-6">
					<div class="h1 text-dark-pink">
						Busca tu carrera
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-12">
					<p>Aquí encontrarás todo el Programa de Actividades que tenemos preparadas para ti entre los
						días 1 y 11 de Marzo. Busca tu carrera, tu año de ingreso. Haz click y encontrarás tus
						horarios para las 2 semanas de Actividades. ¡No te las puedes perder!</p>
				</div>
			</div>
		</div>
		<div class="bg-dark-gray py-5">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-10">
						<img src="/assets/images/programa-induccion-2023.jpg"
						     class="d-block w-100" alt="...">
						<div class="pt-5 text-center">
							<a class="btn btn-lg bg-white text-cyan rounded-pill"
							   target="_blank"
							   href="/assets/images/programa-induccion-2023.pdf">
								<b>Descargar</b>
							</a>
						</div>
						<!--					<div class="row">-->
						<!--						<div v-for="carrera in carreras"-->
						<!--						     class="col-xl-6 col-lg-6 col-md-12 col-sm-12 mb-4">-->
						<!--							<link-to :to="{name: 'programa-carrera', params: {carrera: carrera.route}}" a-class="">-->
						<!--								<div class="zoom-in carreras w-100 h-100 rounded-3 p-3 d-flex justify-content-between"-->
						<!--								     :class="carrera.color">-->
						<!--									<span class="align-self-center text-white h3" v-html="carrera.title"></span>-->
						<!--									<div class="d-flex align-items-center justify-content-end">-->
						<!--										<img :src="'/assets/images/iconos-carreras/' + carrera.image"-->
						<!--										     class="w-50"-->
						<!--										     :alt="carrera.title"/>-->
						<!--									</div>-->
						<!--								</div>-->
						<!--							</link-to>-->
						<!--						</div>-->
						<!--					</div>-->
					</div>
				</div>
			</div>
		</div>
		
		<banda-ver-saludos/>
	</div>
</template>

<script>
import BandaVerSaludos from "../layout/BandaVerSaludos";
import {Mock} from "../common/mock";

export default {
	name: 'programa',
	components: {
		BandaVerSaludos
	},
	data: () => ({
		carreras: Mock.programas
	}),
}
</script>